import { SEO } from '../components/SEO';
import { generateOrganizationSchema, getBaseUrl } from '../utils/seo';
import './PrivacyPage.css';

/**
 * SEO-optimized Privacy Policy Page
 */
export function PrivacyPage() {
  const structuredData = [
    generateOrganizationSchema(getBaseUrl()),
  ];

  return (
    <>
      <SEO
        title="Privacy Policy - Peptide Finder"
        description="Read our privacy policy to understand how Peptide Finder collects, uses, and protects your personal information."
        keywords="privacy policy, data protection, user privacy"
        structuredData={structuredData}
      />
      <div className="privacy-page">
        <header className="privacy-page-header">
          <div className="privacy-page-container">
            <h1>Privacy Policy</h1>
            <p className="privacy-page-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </header>

        <main className="privacy-page-main">
          <div className="privacy-page-container">
            <article className="privacy-page-content">
              <section>
                <h2>Introduction</h2>
                <p>
                  Peptide Finder (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and website.
                </p>
              </section>

              <section>
                <h2>Information We Collect</h2>
                <h3>Information You Provide</h3>
                <p>We may collect information that you provide directly to us, including:</p>
                <ul>
                  <li>Search queries and preferences</li>
                  <li>Feedback and communications</li>
                </ul>

                <h3>Automatically Collected Information</h3>
                <p>When you use our services, we may automatically collect certain information, including:</p>
                <ul>
                  <li>Device information (device type, operating system)</li>
                  <li>Usage data (features used, interactions with the app)</li>
                  <li>Log data (IP address, access times)</li>
                </ul>
              </section>

              <section>
                <h2>How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul>
                  <li>Provide, maintain, and improve our services</li>
                  <li>Personalize your experience</li>
                  <li>Analyze usage patterns and trends</li>
                  <li>Detect and prevent fraud or abuse</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2>Data Sharing and Disclosure</h2>
                <p>We do not sell your personal information. We may share your information only in the following circumstances:</p>
                <ul>
                  <li>With service providers who assist us in operating our services</li>
                  <li>When required by law or to protect our rights</li>
                  <li>In connection with a business transfer or merger</li>
                </ul>
              </section>

              <section>
                <h2>Data Security</h2>
                <p>
                  We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure.
                </p>
              </section>

              <section>
                <h2>Your Rights</h2>
                <p>Depending on your location, you may have certain rights regarding your personal information, including:</p>
                <ul>
                  <li>The right to access your personal information</li>
                  <li>The right to correct inaccurate information</li>
                  <li>The right to delete your information</li>
                  <li>The right to object to processing</li>
                </ul>
              </section>

              <section>
                <h2>Cookies and Tracking Technologies</h2>
                <p>
                  We may use cookies and similar tracking technologies to collect and store information about your preferences and usage patterns.
                </p>
              </section>

              <section>
                <h2>Third-Party Links</h2>
                <p>
                  Our services may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties.
                </p>
              </section>

              <section>
                <h2>Children&apos;s Privacy</h2>
                <p>
                  Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.
                </p>
              </section>

              <section>
                <h2>Changes to This Privacy Policy</h2>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the &quot;Last updated&quot; date.
                </p>
              </section>

              <section>
                <h2>Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us through the app or website.
                </p>
              </section>
            </article>
          </div>
        </main>
      </div>
    </>
  );
}

